import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ErrorPageType } from 'src/app/helpers/enum/error-page-type.enum';
import { InspectionReportDetailsResponse } from 'src/app/models/inspection.model';
import { SqliteStorageService } from 'src/app/services/sqlite-storage/sqlite-storage.service';

export const puiGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const sqliteStorageService = inject(SqliteStorageService);

  const reportId = route.params['reportId'];
  const isEditInspection = reportId != '0';

  const recentVehicleInspection = await sqliteStorageService.getItem<InspectionReportDetailsResponse[]>('recentVehicleInspectionDetails') ?? [];
  const savedDetails = recentVehicleInspection.find(x => x.parent.veH_INSPECT_RPT_DTL_ID === reportId);

  if ((!isEditInspection && !navigator.onLine) || (!savedDetails && !navigator.onLine && isEditInspection)) {
    router.navigate(['/error'], { queryParams: { type: ErrorPageType.NETWORK_ERROR } });
    return false;
  }
  return true;
};
